new Swiper('.main-banner-block .swiper', {
    spaceBetween: 20,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    autoplay: {
        delay: 5000
    },
    loop: true
});
